// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Layout: top filter bar, map fills remaining space */
.map-container {
    display: flex;
    flex-direction: column;
    /* subtract the navbar height (fallback to 0 if variable not defined, e.g. assetmap route) */
    height: calc(100vh - var(--navbar-height, 0px));
    min-height: 400px;
    box-sizing: border-box;
    overflow: hidden; /* prevent the page from scrolling; map will handle interactions */
}

.map-frame-wrapper {
    position: relative;
    flex: 1 1 auto; /* take remaining vertical space */
    min-height: 300px;
    overflow: hidden; /* keep leaflet container from pushing page scrollbars */
}

/* Ensure leaflet container fills its wrapper */
.map-frame-wrapper .leaflet-container {
    height: 100% !important;
    width: 100% !important;
    box-sizing: border-box;
    max-width: 100%; /* prevent accidental horizontal overflow from internal controls */
}
`, "",{"version":3,"sources":["webpack://./src/pages/css/MapPage.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD;IACI,aAAa;IACb,sBAAsB;IACtB,4FAA4F;IAC5F,+CAA+C;IAC/C,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB,EAAE,kEAAkE;AACxF;;AAEA;IACI,kBAAkB;IAClB,cAAc,EAAE,kCAAkC;IAClD,iBAAiB;IACjB,gBAAgB,EAAE,wDAAwD;AAC9E;;AAEA,+CAA+C;AAC/C;IACI,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,eAAe,EAAE,kEAAkE;AACvF","sourcesContent":["/* Layout: top filter bar, map fills remaining space */\n.map-container {\n    display: flex;\n    flex-direction: column;\n    /* subtract the navbar height (fallback to 0 if variable not defined, e.g. assetmap route) */\n    height: calc(100vh - var(--navbar-height, 0px));\n    min-height: 400px;\n    box-sizing: border-box;\n    overflow: hidden; /* prevent the page from scrolling; map will handle interactions */\n}\n\n.map-frame-wrapper {\n    position: relative;\n    flex: 1 1 auto; /* take remaining vertical space */\n    min-height: 300px;\n    overflow: hidden; /* keep leaflet container from pushing page scrollbars */\n}\n\n/* Ensure leaflet container fills its wrapper */\n.map-frame-wrapper .leaflet-container {\n    height: 100% !important;\n    width: 100% !important;\n    box-sizing: border-box;\n    max-width: 100%; /* prevent accidental horizontal overflow from internal controls */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
